import {
    useEffect,
    useState,
} from 'react';


import {useOrganizations} from '../hooks/useOrganizations.ts';
import {Organization} from '../types';
import {FieldProps} from 'formik';
import {
    Autocomplete,
    AutocompleteProps,
    Group,
    Text
} from "@mantine/core";

export const OrganizationsAutocomplete = ({
                                              field,
                                              form,
                                              ...rest
                                          }: FieldProps) => {

    const [value, setValue] = useState<string | undefined>();

    // FNP-948: options come from the React Query cache.
    const {items: organizations} = useOrganizations();

    useEffect(() => {
        const record = organizations.find((record: Organization) => record.id === field.value);
        if (record) {
            setValue(record.name);
        }
    }, [organizations, field.value]);


    const renderAutocompleteOption: AutocompleteProps['renderOption'] = ({option}) => {
        const record = organizations.find((record: Organization) => record.name === option.value);
        if (!record) return null;
        return (
            <Group gap="sm">
                <div>
                    <Text size="sm">{record.name}</Text>
                </div>
            </Group>
        )
    };


    const data = organizations
        .map((record: Organization) => record.name)
        .filter((n): n is string => typeof n === 'string');

    const handleChange = (value: string) => {
        setValue(value);
        const record = organizations.find((record: Organization) => record.name === value);
        if (record) {
            form.setFieldValue(field.name, record.id);
        }
    };

    return (
        <Autocomplete
            name={field.name}
            value={value}
            data={data}
            renderOption={renderAutocompleteOption}
            onChange={handleChange}
            {...rest}
        />
    );
};
